import React, { useEffect, useState } from "react";
import "./Sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import Image from "../../../components/image/Image";
import { AppIcons } from "../../../data/appIcons";
import { Menu } from "../menu/Menu";
import { getData } from "../../../utils/LocalStorage/LocalStorageManager";
const Sidebar = (props) => {
  const [menuList, setMenuList] = useState(Menu)
  const [selectedMenu, setSelectedMenu] = useState(null);
  const location = useLocation();

  const handleClick = (menu) => {
    if (selectedMenu === menu) {
      setSelectedMenu(null); // Remove class if same menu clicked again
    } else {
      setSelectedMenu(menu); // Add class to the clicked menu
    }
  };

  const filterMenuByRole = (menuList, roleId) => {
    const role = String(roleId);
    return menuList
      .filter(menu => menu.securityKey?.includes(role))
      .map(menu => {
        if (menu?.subMenu && Array.isArray(menu?.children)) {
          const filteredChildren = menu?.children?.filter(child => child?.securityKey?.includes(role));
          // Remove parent if no children left
          if (filteredChildren?.length === 0) {
            return null;
          }

          return { ...menu, children: filteredChildren };
        }

        return menu;
      }).filter(Boolean);
  };


  const matchesPath = (currentPath, targetPath) => {
    const target = targetPath.toLowerCase();
    return (
      currentPath === target ||
      (target !== "/" && currentPath.startsWith(target + "/"))
    );
  };

  const isSubMenuActive = (subMenu) => {
    if (!subMenu) return false;
    const currentPath = location.pathname.toLowerCase();
    const paths = [subMenu.to, ...(subMenu.activePaths || [])].filter(Boolean);
    return paths.some((p) => matchesPath(currentPath, p));
  };

  const isMenuItemActive = (menuItem) => {
    if (menuItem.subMenu && Array.isArray(menuItem.children)) {
      return menuItem.children.some((child) => isSubMenuActive(child));
    }
    if (!menuItem.to) return false;
    const currentPath = location.pathname.toLowerCase();
    const targetPath = menuItem.to.toLowerCase();
    return currentPath === targetPath;
  };

  useEffect(() => {
    const roleId = getData("roleId");
    const filteredMenu = filterMenuByRole(Menu, roleId);
    setMenuList(filteredMenu);

    // 👉 Find parent menu based on current route
    const activeMenu = filteredMenu.find((menu) => isMenuItemActive(menu));

    if (activeMenu) {
      setSelectedMenu(activeMenu.id);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="sidebar-section">
        <nav className="sidebar">
          <div className="main-menus">
            <button className="sidebar-toggler" type="button">
              <span className="sidebar-toggler-icon"></span>
            </button>{" "}
            <Link className="sidebar-brand">
              <Image
                imagePath={AppIcons.logoImage}
                imgCustomClassName="open-bar"
                altText="Icon"
              ></Image>
            </Link>
            <div className="sidebar-menu">
              <ul className="sidebar-menu-list">
                {menuList?.map((menuItem, index) => {
                  const isParentOpen = selectedMenu === menuItem.id;
                  const isDirectActive = !menuItem.subMenu && isMenuItemActive(menuItem);

                  return (
                    <li
                      key={index}
                      className={
                        isParentOpen
                          ? "menu-item active-menu"
                          : isDirectActive
                          ? "menu-item active-menu"
                          : "menu-item"
                      }
                      onClick={() => handleClick(menuItem.id)}
                    >
                      <Link
                        to={menuItem.to || "#"}
                        className={menuItem.subMenu ? "menu-arrow" : ""}
                      >
                        <i className={menuItem.iconClass}></i>
                        <span>{menuItem.name}</span>
                      </Link>
                      {menuItem.subMenu ? (
                        <>
                          <ul className="sidebar-dropdown">
                            {menuItem.children.map((subMenu, subIndex) => {
                              const isSubActive = isSubMenuActive(subMenu)
                              return (
                                <li
                                  key={subIndex}
                                  className={`dropdown-menus ${
                                    isSubActive ? "active-submenu" : ""
                                  }`}
                                >
                                  <Link
                                    to={subMenu.to}
                                    className={isSubActive ? "active" : ""}
                                    onClick={(e) => e.stopPropagation()} // ✅ important
                                  >
                                    {subMenu.submenuName}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
